import { ApiError } from "./client";

/**
 * Freshness and retry for the app's reads. Nothing refetches on window focus
 * (query-client.ts); the desk's lists poll on their own clock.
 */

/** Retry only what a retry can fix: no answer (NETWORK) or a dependency that did not answer (503). */
export function retryTransient(failureCount: number, error: unknown): boolean {
	return error instanceof ApiError && error.transient && failureCount < 3;
}

/** Games, sports, venues: they change at setup time, not during a session. */
export const OPTIONS_STALE_MS = 10 * 60_000;
/** The schedule: statuses change by the minute, not the second. */
export const SCHEDULE_STALE_MS = 60_000;
/** The desk's queues and the podium under review: someone else may be at the desk too. */
export const DESK_STALE_MS = 10_000;
/** How often the queue counts in the top band refresh while the app is open. */
export const DESK_POLL_MS = 60_000;
